import { Injectable } from '@angular/core';
import { Filter } from '@idto';

@Injectable({
  providedIn: 'root'
})
export class FilterService
{
  public showAllOptionFilter: Filter[] = [];

  public addShowAllOptionFilter(filter: Filter, b: boolean): void
  {
    if (b)
    {
      this.showAllOptionFilter.push(filter);
    } else
    {
      this.showAllOptionFilter = this.showAllOptionFilter.filter(f => f.code != filter.code);
    }
  }

  public isFilterShowAll(filter: Filter): boolean
  {
    return this.showAllOptionFilter.filter(f => f.code == filter.code).length > 0;
  }
}
